import FamilyDetailsUseCase from "@domains/useCases/Reports/FamilyTagging/FamilyDetails";
import ConsolidateUseCase from "@domains/useCases/Reports/FamilyTagging/ConsolidatedDetails";
import { FamilyDetailsCommonUseCase, SearchUseCase, } from "@domains/useCases/Reports/FamilyTagging/FamilyDetailsCommonUseCase";
export default (repositories) => {
    return {
        consolidatedDetails: new ConsolidateUseCase(repositories.familyTagging),
        familyDetails: new FamilyDetailsUseCase(repositories.familyTagging),
        commonUsecase: new FamilyDetailsCommonUseCase(new SearchUseCase()),
    };
};
